import { Route } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import { NAV_KEYS, SMART_LIBRARY_PATHS } from './types/navigation';
import { SavedAssetsContainer } from './containers/SavedAssetsContainer';
import { AnalyticsSuiteContainer } from './containers/AnalyticsSuiteContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Routes = () => {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: `${SMART_LIBRARY_PATHS[NAV_KEYS.ANALYTICS_SUITE]}/:tabId/:categoryId?`,
      exact: true,
      component: AnalyticsSuiteContainer
    }), /*#__PURE__*/_jsx(Route, {
      path: SMART_LIBRARY_PATHS[NAV_KEYS.USER_LIBRARY],
      component: SavedAssetsContainer
    })]
  });
};